import React from 'react';
import { Copy, Logo, Button } from 'elements';
import { Wrapper, Header, Main, Footer } from 'components';
import { clientConfig } from 'util/config';

import styles from './instagramLogin.scss';

const InstagramLogin = () => {
  const hrefLink = `https://api.instagram.com/oauth/authorize/?client_id=da9cf4332b7b47d29541d48072ed8dc0&redirect_uri=${clientConfig}/instagram&response_type=code`;

  return (
    <Wrapper>
      <Header>
        <Logo gradient />
      </Header>
      <Main>
        <Copy color="black">
          Get one bio link for all your links <br/>
          and add it to Instagram.
        </Copy>
      </Main>
      <Footer>
        <Button primary>
          <a
            href={hrefLink}
            className={styles.instagramLink}
          >
            Login with Instagram
          </a>
        </Button>
      </Footer>
    </Wrapper>
  )
};

export default InstagramLogin;



// WEBPACK FOOTER //
// ./src/pages/instagramLogin/instagramLogin.js